import InfoBarContainer from "./InfoBarContainer";

export default InfoBarContainer;
